<template>
  <form @submit.prevent="addName">
    <label for="name">{{
      members.length > 0 ? "Vous voulez ajouter " : "Vous êtes "
    }}</label>
    <input type="text" name="name" v-model="nameToAdd" />
    <br />

    <div v-if="members.length > 0">
      <label for="to-avoid">qui doit éviter de piocher </label>
      <span style="display: inline-block;">
        <div class="select">
          <select name="to-avoid" v-model="memberToAvoid">
            <option selected disabled>--</option>
            <option v-for="member in members" :value="member.id" :key="member.id" :id="member.id">
              {{ member.name }}
            </option>
          </select>
        </div>
      </span>
    </div>

    <button type="submit">Ajouter</button>
  </form>
</template>

<script>
import { ref } from "vue";
export default {
  props: {
    members: {
      type: Array,
      required: true,
    },
  },
  setup(props, ctx) {
    let nameToAdd = ref(""),
      memberToAvoid = ref("");

    const addName = () => {
      if (nameToAdd.value)
        ctx.emit("add", nameToAdd.value, memberToAvoid.value);
      nameToAdd.value = "";

      if (memberToAvoid.value) {
        console.log("Form | addName() | memberToAvoid", memberToAvoid.value);
        memberToAvoid.value = "";
      }
    };

    return {
      nameToAdd,
      addName,
      memberToAvoid,
    };
  },
};
</script>